<template>
  <highcharts ref="chart" :options="options" />
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'GHGIBar',
  props: {
    ghgi: {
      type: Object,
      default: null
    },
    modules: {
      type: Array,
      default: function () {
        return []
      }
    },
    colors: {
      type: Object
    },
    enabledLabels: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 400
    },
    exporting: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    series: function () {
      let series = []
      for (let module of this.modules) {
        series.push({
          name: this.$t(module),
          y: this.ghgi.carbonSynthesis[module].intensity,
          color: this.colors[module]
        })
      }
      return series.sort((a, b) => b.y - a.y)
    },
    options: function () {
      const self = this
      let yAxiSTitle = ''
      if (this.enabledLabels) {
        yAxiSTitle = this.$t('emissions.t.co2e')
      }
      return {
        chart: {
          type: 'bar',
          height: this.height
        },
        exporting: {
          enabled: this.exporting
        },
        title: {
          text: ''
        },
        xAxis: {
          type: 'category',
          labels: {
            enabled: this.enabledLabels
          }
        },
        yAxis: {
          title: {
            text: yAxiSTitle
          },
          labels: {
            enabled: this.enabledLabels
          }
        },
        plotOptions: {
          series: {
            pointWidth: 20,
            dataLabels: {
              enabled: true,
              formatter () {
                return `${self.$options.filters.splitNumberTons(
                  this.y
                )} ${self.$t('t.co2e')}`
              }
            }
          }
        },
        series: [
          {
            name: this.$t('carbon.footprint'),
            colorByPoint: true,
            data: this.series
          }
        ],
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return `${this.key}<br/><b>${self.$options.filters.splitNumberTons(
              this.y
            )} ${self.$t('t.co2e')}</b>`
          }
        }
      }
    }
  }
}
</script>
